// extracted by mini-css-extract-plugin
export default {"grid":"VideoBlock_grid__8XbEZ","container":"VideoBlock_container__7Cven","video":"VideoBlock_video__6Ntmd","caption":"VideoBlock_caption__gC5wl"};